import { Observable } from 'rxjs';
import { Subject } from 'rxjs';

import { IEvents } from '@true-directive/base';
import { DataQuery } from '@true-directive/base';
import { Column } from '@true-directive/base';
import { CheckedChangedEvent, ValueChangedEvent, FilterShowEvent } from '@true-directive/base';
import { UIAction, UIActionType } from '@true-directive/base';
import { CellPosition } from '@true-directive/base';

export class GridEvents implements IEvents {
  public readonly name = 'events';
  // -- EVENTS -----------------------------------------------------------------
  // ÐÐ°Ð¿ÑÐ¾Ñ Ð´Ð°Ð½Ð½ÑÑ Ñ ÑÐ¾Ð´Ð¸ÑÐµÐ»Ñ
  protected _onDataQuery: Subject<DataQuery> = new Subject();
  public readonly onDataQuery: Observable<DataQuery> = this._onDataQuery.asObservable();

  // ÐÐ¾Ð»ÑÑÐµÐ½Ð¸Ðµ Ð´Ð°Ð½Ð½ÑÑ Ð¾Ñ ÑÐ¾Ð´Ð¸ÑÐµÐ»Ñ
  protected _onDataFetch: Subject<DataQuery> = new Subject();
  public readonly onDataFetch: Observable<DataQuery> = this._onDataFetch.asObservable();

  // ÐÐ·Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ Ð² ÑÐ¿Ð¸ÑÐºÐµ ÐºÐ¾Ð»Ð¾Ð½Ð¾Ðº
  protected _onColumnsChanged: Subject<void> = new Subject();
  public readonly onColumnsChanged: Observable<void> = this._onColumnsChanged.asObservable();

  // ÐÑÐ¸ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸ÑÑ Ð² Ð·Ð°Ð¿ÑÐ¾ÑÐµ Ð´Ð°Ð½Ð½ÑÑ (ÑÐ¾ÑÑÐ¸ÑÐ¾Ð²ÐºÐ°/ÑÐ¸Ð»ÑÑÑ/Ð³ÑÑÐ¿Ð¿Ð¸ÑÐ¾Ð²ÐºÐ°)
  protected _onQueryChanged: Subject<DataQuery> = new Subject();
  public readonly onQueryChanged: Observable<DataQuery> = this._onQueryChanged.asObservable();

  // ÐÑÐ¸ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸ÑÑ Ð³ÑÑÐ¿Ð¿ (ÑÐ²ÐµÑÐ½ÑÑÐ°/ÑÐ°Ð·Ð²ÐµÑÐ½ÑÑÐ°)
  protected _onSummariesChanged: Subject<Column> = new Subject();
  public readonly onSummariesChanged: Observable<Column> = this._onSummariesChanged.asObservable();

  // ÐÑÐ¸ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ð¸ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ñ ÑÑÐµÐ¹ÐºÐ¸
  protected _onValueChanged: Subject<ValueChangedEvent> = new Subject();
  public readonly onValueChanged: Observable<ValueChangedEvent> = this._onValueChanged.asObservable();

  // ÐÑÐ¸ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ð¸ ÑÐµÐºÐ±Ð¾ÐºÑ
  protected _onCheckedChanged: Subject<CheckedChangedEvent> = new Subject();
  public readonly onCheckedChanged: Observable<CheckedChangedEvent> = this._onCheckedChanged.asObservable();

  // ÐÐµÑÐµÑÐ°ÑÐºÐ¸Ð²Ð°Ð½Ð¸Ðµ ÐºÐ¾Ð»Ð¾Ð½ÐºÐ¸
  // Ð¢Ð°ÑÐ¸Ð¼
  protected _onDrag: Subject<UIAction> = new Subject();
  public readonly onDrag: Observable<UIAction> = this._onDrag.asObservable();

  // ÐÑÐ¾ÑÐ°ÐµÐ¼
  protected _onDrop: Subject<UIAction> = new Subject();
  public readonly onDrop: Observable<UIAction> = this._onDrop.asObservable();

  // ÐÐ·Ð¼ÐµÐ½ÐµÐ½Ð¸Ðµ ÑÐ¸ÑÐ¸Ð½Ñ ÐºÐ¾Ð»Ð¾Ð½ÐºÐ¸
  // Ð¢Ð°ÑÐ¸Ð¼
  protected _onColumnResizing: Subject<UIAction> = new Subject();
  public readonly onColumnResizing: Observable<UIAction> = this._onColumnResizing.asObservable();

  // ÐÑÐ¾ÑÐ°ÐµÐ¼
  protected _onColumnResize: Subject<UIAction> = new Subject();
  public readonly onColumnResize: Observable<UIAction> = this._onColumnResize.asObservable();

  // ÐÑÐ¸ ÑÐ¸Ð»ÑÑÑÐ°ÑÐ¸Ð¸
  protected _onFilterShow: Subject<FilterShowEvent> = new Subject();
  public readonly onFilterShow: Observable<FilterShowEvent> = this._onFilterShow.asObservable();

  // ÐÑÐ´ÐµÐ»ÐµÐ½Ð¸Ðµ ÑÑÐµÐ¹ÐºÐ¸/ÑÑÑÐ¾ÐºÐ¸/Ð¾Ð±Ð»Ð°ÑÑÐ¸
  protected _onSelect: Subject<CellPosition> = new Subject();
  public readonly onSelect: Observable<CellPosition> = this._onSelect.asObservable();

  // ÐÐºÐ»ÑÑÐµÐ½Ð¸Ðµ ÑÐµÐ´Ð°ÐºÑÐ¾ÑÐ°
  protected _onStartEditing: Subject<CellPosition> = new Subject();
  public readonly onStartEditing: Observable<CellPosition> = this._onStartEditing.asObservable();

  // ÐÑÐºÐ»ÑÑÐµÐ½Ð¸Ðµ ÑÐµÐ´Ð°ÐºÑÐ¾ÑÐ°
  protected _onStopEditing: Subject<boolean> = new Subject();
  public readonly onStopEditing: Observable<boolean> = this._onStopEditing.asObservable();

  // Ð¡ÑÑÐ¾ÐºÐ° Ð¿ÐµÑÐµÑÑÐ°Ð»Ð° Ð±ÑÑÑ Ð²Ð¸Ð´Ð¸Ð¼Ð¾Ð¹ Ð¿Ð¾ÑÐ»Ðµ ÑÐµÐ´Ð°ÐºÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ
  protected _onRowUnfiltered: Subject<any> = new Subject();
  public readonly onRowUnfiltered: Observable<any> = this._onRowUnfiltered.asObservable();

  // ÐÐ¾Ð½ÑÐµÐºÑÑÐ½Ð¾Ðµ Ð¼ÐµÐ½Ñ ÐºÐ¾Ð»Ð¾Ð½ÐºÐ¸
  protected _onHeaderContextMenu: Subject<any> = new Subject();
  public readonly onHeaderContextMenu: Observable<any> = this._onHeaderContextMenu.asObservable();

  // Ð¡Ð¾Ð±ÑÑÐ¸Ðµ ÐºÐ°ÑÑÐ¾Ð¼Ð½Ð¾Ð¹ ÑÑÐµÐ¹ÐºÐ¸
  protected _onCustomCellEvent: Subject<any> = new Subject();
  public readonly onCustomCellEvent: Observable<any> = this._onCustomCellEvent.asObservable();

  public dataQueryEvent(query: DataQuery) {
    this._onDataQuery.next(query);
  }

  public dataFetchEvent(query: DataQuery) {
    if (query.subject) {
      query.subject.next();
      query.subject.complete();
    }
    this._onDataFetch.next(query);
  }

  public columnsChangedEvent() {
    this._onColumnsChanged.next();
  }

  public queryChangedEvent(query: DataQuery) {
    this._onQueryChanged.next(query);
  }

  public summariesChangedEvent(c: Column) {
    this._onSummariesChanged.next(c);
  }

  public valueChangedEvent(e: ValueChangedEvent) {
    this._onValueChanged.next(e);
  }

  public checkedChangedEvent(e: CheckedChangedEvent) {
    this._onCheckedChanged.next(e);
  }

  public dragEvent(e: UIAction) {
    this._onDrag.next(e);
  }

  public dropEvent(e: UIAction) {
    this._onDrop.next(e);
  }

  public columnResizeEvent(e: UIAction) {
    this._onColumnResize.next(e);
  }

  public filterShowEvent(e: FilterShowEvent) {
    this._onFilterShow.next(e);
  }

  public selectEvent(cp: CellPosition) {
    this._onSelect.next(cp);
  }

  public startEditingEvent(cp: CellPosition) {
    this._onStartEditing.next(cp);
  }

  public stopEditingEvent(returnFocus: boolean) {
    this._onStopEditing.next(returnFocus);
  }

  public headerContextMenuEvent(e: { originalEvent: any, column: Column }) {
    this._onHeaderContextMenu.next(e);
  }

  public customCellEvent(e: any) {
    this._onCustomCellEvent.next(e);
  }
}
